import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

// import { getVisibleItems } from 'resolvers/getVisibleEntities';
// import { REDUCER } from 'constants/entity-names';
// import { getStore } from 'store';

// get store
// const store = getStore();

/*************************************************************/

/**
 * @type {class}
 * @desc SetPatientNotes defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { SetPatientNotesService } from 'services/setPatientNotes';
 *
 * // create service instance and send/cancel request
 * const setPatientNotesService = new SetPatientNotesService();
 * const result = await setPatientNotesService.fetchData( '<user-id>' ); // fetch data
 * setPatientNotesService.cancel(); // cancel an active request
 */
export class SetPatientNotesService extends HttpService {

    // submit form data
    async submitFormData( { url, data } ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: data
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE )
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE
            };
        }
    }

    async setPatientNotesData( { url, data  } ) {

        // get ongoing call info from the redux store
        // const callId = get( store.getState()[ REDUCER.CALL_STATE ], 'callId', null );

        const response = await this.post( {
            host: CONFIG.host,
            path: url,
            data: data,
        } );

        // extract component data
        const values = get( response, 'body.component.data', [] );
        
        // const fields = get( response, 'body.component.structure.fields', [] );
        // const visibility = get( response, 'body.component.visibility' );
        
        return {
            status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.ERROR ),
            data: {
                values,
                
                // ...get( response, 'body.component.structure', [] ),
                // fields: getVisibleItems( fields, visibility )
            }
        };
    }

    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
